// The ad platforms whose write tools never run straight from an "allow"
// policy: the write is filed as a proposal and runs only after approval.
// Both spellings of a platform key are listed (`facebook` / `facebook_ads`).
const PROPOSAL_FIRST_PLATFORMS = new Set([
  'facebook',
  'facebook_ads',
  'meta',
  'meta_ads',
  'google_ads',
  'tiktok',
  'tiktok_ads',
  'linkedin',
  'linkedin_ads',
  'snapchat',
  'snapchat_ads',
]);

/** True when an allowed write on this platform is still filed as a proposal. */
export function allowedWriteIsFiledAsProposal(
  platformKey: string | null | undefined
): boolean {
  if (!platformKey) return false;
  return PROPOSAL_FIRST_PLATFORMS.has(platformKey.trim().toLowerCase());
}
